export default "__VITE_ASSET__O1cd4KEb__"